<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/category']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'category_common_name' | translate"></nz-statistic>
    </a>
</nz-card>